'use client';

import { Chevron } from '@sprd/sprd-component-kit/v2';
import React, { useId, useState } from 'react';

interface SingleFaqProps {
  question: string;
  answer: React.ReactNode;
}

export default function SingleFaq({ question, answer }: SingleFaqProps) {
  const [showAnswer, setshowAnswer] = useState(false);
  const id = useId();
  return (
    <div className="mb-4 border-2 border-solid p-4">
      <button
        className="w-full"
        onClick={() => setshowAnswer(!showAnswer)}
        id={`faq-${id}`}
        aria-expanded={showAnswer}
        aria-controls={`faq-answer-${id}`}
      >
        <div className="flex flex-row items-start justify-between text-sm font-bold md:text-base">
          {question}
          <span
            className={
              showAnswer
                ? 'rotate-180 text-2xl transition duration-500'
                : 'rotate-0 text-2xl transition duration-500'
            }
          >
            <Chevron />
          </span>
        </div>
      </button>
      <div
        id={`faq-answer-${id}`}
        className={
          showAnswer
            ? 'h-auto overflow-auto pt-4 transition-all duration-150'
            : 'h-0 overflow-hidden transition-all duration-150'
        }
      >
        <div className="text-left text-sm md:text-base">{answer}</div>
      </div>
    </div>
  );
}
